import ButtonIcon from "#common/buttons/ButtonIcon"
import BeenhereIcon from "@mui/icons-material/Beenhere"
import DescriptionIcon from "@mui/icons-material/Description"
import { Stack } from "@mui/material"
import { Fragment, useState } from "react"
import ActionPlanEvidence from "./ActionPlanEvidence"
import ActionPlanFinished from "./ActionPlanFinished"
import DeleteIcon from "@mui/icons-material/Delete"
import ActionPlanEvidenceDelete from "./ActionPlanEvidenceDelete"
import ActionPlanDelete from "./ActionPlanDelete"
import ContentPasteOffIcon from "@mui/icons-material/ContentPasteOff"
import { STATUS_PLAN_ACTION } from "#performance-evaluation/constants"
import { UseHasPermission } from "#hooks/useHasPermission"
import PERMISOS from "#constants/perfiles"
import { ViewPdfDialog } from "#core/components/view-pdf/ViewPdf"
import PreviewIcon from "@mui/icons-material/Preview"
import { evaluationActionPlanIdGet } from "#performance-evaluation/services/api"

/**
 * @typedef {Object} ActionPlan
 * @property {Array} actions
 * @property {string} commitment_date
 * @property {number} competencia
 * @property {string} competencia_name
 * @property {string} created_at
 * @property {number} evaluation
 * @property {number} id
 * @property {boolean} is_active
 * @property {string} objective
 * @property {number} status
 * @property {string} status_name
 * @property {boolean} url_s3
 */

/**
 * @param {Object} props
 * @param {ActionPlan} props.actionPlan
 */
export default function ActionPlanButtons({ actionPlan }) {
	const isRH = UseHasPermission(PERMISOS.RH)
	const [openEvidence, setOpenEvidence] = useState(false)
	const [openEvidenceDelete, setOpenEvidenceDelete] = useState(false)
	const [openFinished, setOpenFinished] = useState(false)
	const [openDelete, setOpenDelete] = useState(false)
	const [open, setOpen] = useState(false)
	const buttons = []

	if (actionPlan.url_s3)
		buttons.push(
			<ButtonIcon
				title="Ver evidencia"
				icon={<PreviewIcon />}
				onClick={() => setOpen(true)}
				hidden={!isRH}
			/>,
		)
	if (actionPlan.is_active) {
		if (!actionPlan.url_s3) {
			buttons.push(
				<ButtonIcon
					key="add-evidence"
					title="Agregar evidencias"
					icon={<DescriptionIcon />}
					onClick={() => setOpenEvidence(true)}
				/>,
				<ButtonIcon
					title="Eliminar Plan de Acción"
					icon={<DeleteIcon />}
					onClick={() => setOpenDelete(true)}
					color="error"
					hidden={!isRH}
				/>,
			)
		}
		if (actionPlan.url_s3)
			buttons.push(
				<ButtonIcon
					title="eliminar evidencias"
					icon={<ContentPasteOffIcon />}
					onClick={() => setOpenEvidenceDelete(true)}
				/>,
			)

		buttons.push(
			<ButtonIcon
				title="Finalizar"
				icon={<BeenhereIcon />}
				onClick={() => setOpenFinished(true)}
				color="success"
				hidden={actionPlan.status !== STATUS_PLAN_ACTION.IN_PROGRESS || !isRH}
			/>,
		)
	}

	return (
		<Fragment>
			<Stack direction={"row"}>{buttons}</Stack>
			<ActionPlanEvidence
				open={openEvidence}
				setOpen={setOpenEvidence}
				actionPlan={actionPlan}
			/>
			<ActionPlanEvidenceDelete
				open={openEvidenceDelete}
				setOpen={setOpenEvidenceDelete}
				actionPlan={actionPlan}
			/>
			<ActionPlanFinished
				open={openFinished}
				setOpen={setOpenFinished}
				actionPlan={actionPlan}
			/>
			<ActionPlanDelete
				open={openDelete}
				setOpen={setOpenDelete}
				actionPlan={actionPlan}
			/>
			<ViewPdfDialog
				open={open}
				setOpen={setOpen}
				apiGet={evaluationActionPlanIdGet}
				moreParams={{ id: actionPlan.id }}
			/>
		</Fragment>
	)
}
